import { LINKS } from "@/lib/api";
import logo from "@/assets/logo_ethos.png";

export const Footer = () => {
  return (
    <footer className="bg-ink2 crosshatch text-white" data-testid="footer">
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-12 grid gap-8 md:grid-cols-3 items-center">
        <div data-testid="footer-logo">
          <img src={logo} alt="Ethos Foundation" className="h-12 w-auto" />
          <div className="font-body-eth text-[11px] tracking-[0.28em] uppercase text-white/40 mt-3">
            Fostering Unity Through Community
          </div>
        </div>
        <div className="text-center font-body-eth text-[13px] text-white/55 leading-relaxed">
          © 2026 Ethos Foundation · 501(c)(3)
          <br />
          <a href={`mailto:${LINKS.email}`} className="text-glow hover:underline">
            {LINKS.email}
          </a>
        </div>
        <div className="md:text-right font-body-eth text-[12px] tracking-[0.24em] uppercase text-white/40">
          <span style={{ opacity: 0.45 }}>Pages for Progress</span>
        </div>
      </div>
    </footer>
  );
};
